import { useLocation } from 'react-router-dom';

export const SUPPORTED_LANGS = ['en', 'de'] as const;
export type Lang = typeof SUPPORTED_LANGS[number];

const useLang = (): Lang => {
  const { pathname } = useLocation();
  const segment = pathname.split('/')[1] as Lang;
  return SUPPORTED_LANGS.includes(segment) ? segment : 'en';
};

export default useLang;
